module.exports = __webpack_public_path__ + "img/teaching_5_zh.45c0345e.png";